import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger, DrawSVGPlugin );

      const section = document.querySelector( '[data-component="book-journey"]' );
      if ( !section ) return;

      const stepsContainer = section.querySelector( '[data-book-journey-steps]' );
      const svg = section.querySelector( '[data-book-journey-svg]' );
      const pathEl = section.querySelector( '[data-book-journey-path]' );
      const rows = section.querySelectorAll( '[data-book-journey-row]' );

      if ( !stepsContainer || !svg || !pathEl || !rows.length ) return;

      const buildAndAnimate = () => {
        this.buildPath( stepsContainer, svg, pathEl, rows );

        gsap.set( pathEl, {drawSVG: '0%'} );

        ScrollTrigger.getAll().forEach( ( t ) => {
          if ( t.vars.id === 'book-journey-path' ) t.kill();
        } );

        gsap.to( pathEl, {
          drawSVG: '100%',
          ease: 'none',
          scrollTrigger: {
            id: 'book-journey-path',
            trigger: stepsContainer,
            start: 'top center',
            end: 'bottom center',
            scrub: 1,
          },
        } );
      };

      buildAndAnimate();

      let resizeTimer;
      window.addEventListener( 'resize', () => {
        clearTimeout( resizeTimer );
        resizeTimer = setTimeout( buildAndAnimate, 200 );
      } );
    },

    buildPath: function( container, svg, pathEl, rows ) {
      const containerRect = container.getBoundingClientRect();
      const W = containerRect.width;
      const H = containerRect.height;

      svg.setAttribute( 'viewBox', `0 0 ${W} ${H}` );

      const isMobile = window.innerWidth < 1024;
      const MOBILE_RADIUS = 40;

      const segments = [];
      let isFirst = true;

      rows.forEach( ( row ) => {
        const rowRect = row.getBoundingClientRect();
        const x = rowRect.left - containerRect.left;
        const y = rowRect.top - containerRect.top;
        const w = rowRect.width;
        const h = rowRect.height;
        const side = row.dataset.bookJourneyRow;
        const halfW = w / 2;
        const cx = x + halfW;

        if ( isFirst ) {
          segments.push( `M ${cx - 28} ${y - 28}` );
          segments.push( `A 28 28 0 0 0 ${cx} ${y}` );
          segments.push( `L ${cx} ${y}` );
          isFirst = false;
        } else {
          segments.push( `L ${cx} ${y}` );
        }

        if ( isMobile ) {
          const r = MOBILE_RADIUS;

          if ( side === 'right' ) {
            segments.push( `L ${x + w - r} ${y}` );
            segments.push( `A ${r} ${r} 0 0 1 ${x + w} ${y + r}` );
            segments.push( `L ${x + w} ${y + h - r}` );
            segments.push( `A ${r} ${r} 0 0 1 ${x + w - r} ${y + h}` );
          } else {
            segments.push( `L ${x + r} ${y}` );
            segments.push( `A ${r} ${r} 0 0 0 ${x} ${y + r}` );
            segments.push( `L ${x} ${y + h - r}` );
            segments.push( `A ${r} ${r} 0 0 0 ${x + r} ${y + h}` );
          }
        } else {
          const r = Math.min( h / 2, halfW );

          if ( side === 'right' ) {
            const arcX = x + w - r;
            segments.push( `L ${arcX} ${y}` );
            segments.push( `A ${r} ${r} 0 1 1 ${arcX} ${y + h}` );
          } else {
            const arcX = x + r;
            segments.push( `L ${arcX} ${y}` );
            segments.push( `A ${r} ${r} 0 1 0 ${arcX} ${y + h}` );
          }
        }

        segments.push( `L ${cx} ${y + h}` );
      } );

      const lastRect = rows[rows.length - 1].getBoundingClientRect();
      const endCx = lastRect.left - containerRect.left + lastRect.width / 2;
      const endY = lastRect.bottom - containerRect.top;
      segments.push( `A 28 28 0 0 1 ${endCx + 28} ${endY + 28}` );

      pathEl.setAttribute( 'd', segments.join( ' ' ) );
    },

    finalize: function() {},
  };

  app.registerComponent( 'book-journey', COMPONENT );
} )( app );
